import { Suspense, useMemo } from 'react';
import { Navigate } from 'react-router-dom';

import { FullContainerSpinner } from 'components/ContainerSpinner';
import { useCurrent } from 'features/auth';

interface NotificationSystemGuardProps {
  children: React.ReactNode;
}

export const NotificationSystemGuard = ({ children }: NotificationSystemGuardProps) => {
  const { data, loading } = useCurrent();

  const isEnabled = useMemo(() => {
    const settings = data?.current?.customerSettings ?? [];
    return (
      settings.includes('branding_configuration_feature') &&
      settings.includes('customer_portal_v2_feature')
    );
  }, [data]);

  if (loading) {
    return (
      <Suspense fallback={<FullContainerSpinner />}>
        <FullContainerSpinner />
      </Suspense>
    );
  }

  if (!isEnabled) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
